module.exports = __webpack_public_path__ + "media/images/home-04e875c2ad44a6f5338437f3c3329ee5.svg";